module.exports = __webpack_public_path__ + "img/faq.f2c2e5fe.svg";